export const cms: any = {
  title: "Title",
  summary: "Summary",
  tagList: "Tag list",
  lineFooterText: "Fixed LINE button text",
  relatedPostIds: "Related posts",
  scheduledApplyAt: "Scheduled apply at",
  searchTypes: "Search display type",
};
